export default {
    name: "PeopleController",

    data() {
        return {
            menu: [
                {
                    title: "Logistics",
                    icon: "mdi-clipboard-text",
                    route: "logistics",
                },
                {
                    title: "Holiday",
                    icon: "mdi-calendar-range",
                    route: "holidays.index",
                },
                {
                    title: "Expenses",
                    icon: "mdi-cash",
                    route: "expense-sheets.index",
                },
                {
                    title: "Training",
                    icon: "mdi-school",
                    route: "training",
                },
                {
                    title: "Timesheets",
                    icon: "mdi-table",
                    route: "timesheets.index",
                },
            ],
        };
    },
    mounted() {
        this.generateMenu();
        this.$root.store.sideMenuTitle = "People";
    },

    methods: {
        generateMenu() {
            this.$root.store.sideMenu = this.menu;
        },
    },
};
